import useMenus from '../Menus/useMenus'
import { menuToProducts } from '../utils/menuReducer'

export default function useProducts() {
  const menus = useMenus()
  return menus?.reduce(menuToProducts, [])
}
